import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useQueryClient } from "@tanstack/react-query";
import React, { ChangeEvent, FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isDevelopmentEnvironment } from "@/common/helpers/environment.helper";
import { DEVICE_OPTIONS_QUERY_KEY } from "@/services/device-options/device-options.constants";
import { SCENARIO_QUERY_PARAM } from "../../mock-device-options-service";
import { resolveScenario, SCENARIO_LABELS, ScenarioId } from "../../scenarios";

const PICKER_ID = "device-options-scenario-picker";

export const DeviceOptionsScenarioPicker: FC = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const queryClient = useQueryClient();

  if (!isDevelopmentEnvironment()) {
    return null;
  }

  const selectedScenario = resolveScenario(
    new URLSearchParams(search).get(SCENARIO_QUERY_PARAM) ?? ""
  ).id;

  const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    const params = new URLSearchParams(search);
    params.set(SCENARIO_QUERY_PARAM, event.target.value);
    history.replace(`${pathname}?${params.toString()}`);
    queryClient.invalidateQueries({ queryKey: DEVICE_OPTIONS_QUERY_KEY });
  };

  return (
    <Col gridGap="S100" width="fit-content" data-testid="device-options-scenario-picker">
      <Text fontSize="T100" color="neutral70">
        <label htmlFor={PICKER_ID}>Simulation scenario</label>
      </Text>
      <select id={PICKER_ID} value={selectedScenario} onChange={onChange}>
        {(Object.entries(SCENARIO_LABELS) as [ScenarioId, string][]).map(([id, label]) => (
          <option key={id} value={id}>
            {label}
          </option>
        ))}
      </select>
    </Col>
  );
};
